module.exports = __webpack_public_path__ + "static/media/291570.6bb93b7a.png";